import _ from "lodash";
import axios from "axios";
import {
  BASE_IMAGES_URL,
  APP_API_KEY,
  INSTANCE_URL,
  itemCount,
  UPLOAD_FILES_API_KEY,
} from "Constants";
import {
  getRequest,
  postRequest,
  deleteRequest,
  fileUploadRequest,
  uploadEncodedFile,
  patchRequest,
} from "NetworkCall";
import { getHeaders } from "CommonUtils";
export var FETCH_GALLERY_IMAGES = "FETCH_GALLERY_IMAGES";
export var GALLERY_IMAGE_TO_UPLOAD = "GALLERY_IMAGE_TO_UPLOAD";
export var THUMBNAIL_GALLERY_IMAGE_TO_UPLOAD =
  "THUMBNAIL_GALLERY_IMAGE_TO_UPLOAD";
export var OPEN_GALLERY_MODAL = "OPEN_GALLERY_MODAL";

export function fetchGalleryImages(session, pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${itemCount}&offset=${offset}&`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/gallery?${offSetQuery}include_count=true&filter=eventid=${session.eventid}&order=createon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: FETCH_GALLERY_IMAGES, payload: data });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function updateLocalSort(data) {
  return {
    type: FETCH_GALLERY_IMAGES,
    payload: data,
  };
}

export function openModal(data) {
  return {
    type: OPEN_GALLERY_MODAL,
    payload: data,
  };
}

export function thumbnailImageUpload(imagedata = {}) {
  return {
    type: THUMBNAIL_GALLERY_IMAGE_TO_UPLOAD,
    payload: imagedata,
  };
}

export function ImageToUpload(imagedata = {}) {
  return {
    type: GALLERY_IMAGE_TO_UPLOAD,
    payload: imagedata,
  };
}

export function uploadGalleryImage(
  imageData,
  imagefilename,
  session,
  callback
) {
  var originalImageBase64 = imageData;
  originalImageBase64 = originalImageBase64.replace(
    /^data:image\/[a-z]+;base64,/,
    ""
  );
  var originalFilename = imagefilename;

  var originalImageJson = {
    resource: [
      {
        name: originalFilename,
        type: "file",
        is_base64: true,
        content: originalImageBase64,
      },
    ],
  };
  return (dispatch) => {
    // uploadEncodedFile(`${BASE_IMAGES_URL}?check_exist=false`,session, originalImageJson, dispatch, (data) => {
    //   callback("uploaded")
    // }, (error) => {
    //   callback("failed");
    // });
  };
}

export function addImageToGallery(data, session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/gallery`;
  var sentData = [
    {
      eventid: session.eventid,
      thumbpath: data.thumbfilename,
      imagepath: data.originalfilename,
    },
  ];
  var body = { resource: sentData };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(fetchGalleryImages(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function uploadNewImage(finalData, session, callback) {
  var eventid = session.eventid;
  var originalImageBase64 = finalData.original;
  originalImageBase64 = originalImageBase64.replace(
    /^data:image\/[a-z]+;base64,/,
    ""
  );
  var originalFilename = `eventify/${eventid}/images/galleryimages/${finalData.originalName}.jpg`;

  var thumbnailImageBase64 = finalData.thumbnail;
  thumbnailImageBase64 = thumbnailImageBase64.replace(
    /^data:image\/[a-z]+;base64,/,
    ""
  );
  var thumbnailFilename = `eventify/${eventid}/images/galleryimages/${finalData.thumbnailName}.jpg`;
  var originalImageJson = {
    resource: [
      {
        name: originalFilename,
        type: "file",
        is_base64: true,
        content: originalImageBase64,
      },
    ],
  };

  var thumbnailImageJson = {
    resource: [
      {
        name: thumbnailFilename,
        type: "file",
        is_base64: true,
        content: thumbnailImageBase64,
      },
    ],
  };

  return (dispatch) => {
    var config = {
      headers: {
        "X-DreamFactory-Api-Key": UPLOAD_FILES_API_KEY,
        "X-DreamFactory-Session-Token": session.sessionToken,
        contentType: "application/json; charset=utf-8",
      },
    };

    axios
      .post(`${BASE_IMAGES_URL}?check_exist=false`, originalImageJson, config)
      .then(function (res) {
        // var response1=res.data.resource[0];

        axios
          .post(
            `${BASE_IMAGES_URL}?check_exist=false`,
            thumbnailImageJson,
            config
          )
          .then(function (res1) {
            // var response2=res1.data.resource[0];

            var url = `${INSTANCE_URL}/api/v2/eventify/_table/gallery`;
            var sentData = [
              {
                eventid: session.eventid,
                thumbpath: thumbnailFilename,
                imagepath: originalFilename,
              },
            ];
            var body = { resource: sentData };

            postRequest(
              url,
              body,
              session,
              dispatch,
              (response) => {
                dispatch(fetchGalleryImages(session));
                callback({ success: 1 });
              },
              (error) => {
                callback({ success: 0, message: error });
              }
            );
          })
          .catch(function (err) {});
      })
      .catch(function (err) {});
  };
}

export function uploadImagesServerSide(session, filesArray, callback) {
  var params = {
    eventid: session.eventid,
    filesArray: filesArray,
  };

  var url = `${INSTANCE_URL}/api/v2/eventifyscript/uploadGalleryImages`;
  return (dispatch) => {
    postRequest(
      url,
      params,
      session,
      dispatch,
      (response) => {
        dispatch(fetchGalleryImages(session));
        callback({ success: 1, response: response });
      },
      (error) => {
        callback({ success: 0, response: error });
      }
    );
  };
}

export function deleteImage(session, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/gallery/${id}`;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function updateSortGallery(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/gallery`;
  var data = _.map(values, (obj) => ({
    id: obj.id,
    displayorder: obj.displayorder,
    eventid: session.eventid,
  }));
  var body = { resource: data };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        callback({ success: 1, data: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}
